import type React from 'react';
import { ImportHistoryTable } from './ImportHistoryTable';
import { useImportHistory } from './useImportHistory';

type ImportHistoryContentProps = {
    branchId: string;
};

/** The history inside its boundary: the hook's state, rendered by the table. */
export const ImportHistoryContent: React.FC<ImportHistoryContentProps> = ({
    branchId,
}) => {
    const { history, isNarrow } = useImportHistory(branchId);

    return <ImportHistoryTable history={history} isNarrow={isNarrow} />;
};
